




import Vue from "vue";
export default Vue.extend({
  name: "ValidateButton",
  props: {
    title: {
      type: String,
      default: "Button"
    },
    loading: {
      type: Boolean,
      default: false
    },
    onclick: {
      type: Function,
      default: () => undefined
    }
  }
});
